'use client';
import { useMemo } from 'react';
import { ThemeLayout } from './ThemeLayout';
import { SliderLayout } from '@/src/components/Layout/SliderLayout';
import { ICmsBranch, ICmsSection } from '../services/types';
import Container from '@/src/components/ui/container';
import Typography from '@/src/components/ui/typography';
import CmsStoreCard from './CmsStoreCard';

type Props = {
  section: ICmsSection;
};

export const NewTrendingStores = ({ section }: Props) => {
  const { content, theme, name, id } = section;

  const parsedSection = useMemo(() => {
    return (Array.isArray(content) ? content : (content?.stores ?? [])) as ICmsBranch[];
  }, [content]) as ICmsBranch[];

  return (
    <Container>
      <ThemeLayout
        id={id.toString()}
        theme={theme}
        alt="trading Stores"
        header={
          <Typography
            variant="h4"
            component={'h2'}
            weight={'semibold'}
            align="start"
            className="text-inherit"
          >
            {name}
          </Typography>
        }
      >
        {parsedSection?.length > 0 && (
          <SliderLayout
            itemsClassName="lg:basis-[12%] md:basis-[16%] basis-[32%] md:pl-4 pl-2"
            conatinerClassName="lg:ps-6 ps-3"
          >
            {parsedSection.map((store, index) => (
              <CmsStoreCard key={index} store={store} />
            ))}
          </SliderLayout>
        )}
      </ThemeLayout>
    </Container>
  );
};
